import dayjs from 'dayjs'
import React from 'react'

import { Translate } from '@hozana/intl/Translate'

import { TPProps } from 'elements/text/P'
import { Text } from 'elements/text/Text'
import { Label } from 'elements/ui/Label'

import { COMMUNITY_LIFETIME } from 'modules/community/constants'
import { isNovenaOrRetreat } from 'modules/community/functions'
import { useCommunityFrequency } from 'modules/community/hooks/useCommunityFrequency'
import type { TCommunity } from 'modules/community/types'

export type TPublicationHeaderDatesProps = {
  community: TCommunity
} & TPProps

export const PublicationHeaderDates: TFC<TPublicationHeaderDatesProps> = ({ community }) => {
  const isMultipleMonthSubscription = !dayjs(community.subscription?.toDate).isSame(
    dayjs(community.subscription?.fromDate),
    'month',
  )
  const formattedSubscriptionFromDate = dayjs(community.subscription?.fromDate).format(
    isMultipleMonthSubscription ? 'DD MMMM' : 'DD',
  )
  const formattedSubscriptionToDate = dayjs(community.subscription?.toDate).format('DD MMMM YYYY')
  const { frequencyText } = useCommunityFrequency({ community })
  const novenaOrRetreat = isNovenaOrRetreat(community)

  return (
    <Label colors="info">
      {novenaOrRetreat ? (
        <>
          <Text bold="semi" vAlign="initial" firstUpper>
            {community.lifetime === COMMUNITY_LIFETIME.NOVENA
              ? 'trans:publication:word.novena'
              : 'trans:publication:word.retreat'}
          </Text>
          &nbsp;-&nbsp;
          <Translate values={{ fromDate: formattedSubscriptionFromDate, toDate: formattedSubscriptionToDate }}>
            trans:publication:community.date.from-to
          </Translate>
        </>
      ) : (
        <Text bold="semi" vAlign="initial">
          {frequencyText}
        </Text>
      )}
    </Label>
  )
}
